import {GridValueGetterParams} from "@mui/x-data-grid/models/params/gridCellParams";

export const stereotypeGetter = (params: GridValueGetterParams) => {
    return params.row.stereotype?.name;
}
